import Vue from 'vue'
import Router from 'vue-router'
import { getToken, setToken } from '@/utils/auth' // get token from cookie
import { headerInfo } from "@/api/header";
import store from '@/store'
import { organization } from '@/utils/common'
import { Message } from 'element-ui';

const home = () => import('@/pages/home/home')
const searchIndustry = () => import('@/pages/search/search_from_industry')
const album = () => import('@/pages/album/album')
// const play=()=>import('@/pages/play/play')
const play = () => import('@/pages/play/index')
const personal = () => import('@/pages/personal/personal')
const study = () => import('@/pages/study/study')
const login = () => import('@/pages/login/index')
const homework = () => import('@/pages/homework')
const live = () => import('@/pages/live')
const exam = () => import('@/pages/exam')
const certificate = () => import('@/pages/exam/certificate.vue')
const custom = () => import('@/pages/custom/index.vue')
const noPage = () => import('@/pages/error-page/404')
Vue.use(Router)
// 非学员登录
const routes = [
  {
    path: '/expired',
    component: () => import('@/pages/overdue/expired'),
    hidden: true
  },
  {
    path: '/404page',
    name: '404',
    component: () => import('@/pages/overdue/404page'),
    hidden: true
  },
  {
    path: '/405page',
    component: () => import('@/pages/overdue/405page'),
    hidden: true
  },
  {
    path: '/lookfail',
    component: () => import('@/pages/error-page/lookfail'),
    hidden: true
  },
  {
    path: '/exam/:id',
    name: 'exam',
    component: exam,
    meta: {
      title: '课程考试页-翼狐云课堂'
    }
  },
  {
    path: '/certificate',
    name: 'certificate',
    component: certificate,
    meta: {
      title: '课程考试页-翼狐云课堂'
    }
  },

  {
    path: '/course/:ids?/',
    name: 'searchIndustry',
    component: searchIndustry,
    meta: {
      title: '课程中心-翼狐云课堂'
    }
  },
  {
    path: '/a/:aid',
    name: 'album',
    component: album,
    meta: {
      title: '课程详情页-翼狐云课堂'
    }
  },
  {
    path: '/p/:vid/:vstatus',
    name: 'play',
    component: play,
    meta: {
      title: '课程播放页-翼狐云课堂'
    }
  },
  {
    path: '/u/:compName?/',
    name: 'personal',
    component: personal,
    meta: {
      title: '个人中心-翼狐云课堂'
    }
  },
  {
    path: '/s/:compName?/:type?',
    name: 'study',
    component: study,
    meta: {
      title: '学习中心-翼狐云课堂'
    }
  },
  {
    path: '/homework/:videoId/:ind',
    name: 'homework',
    component: homework,
    meta: {
      title: '',
      description: '',
      keywords: ''
    }
  },
  {
    path: '/live/:vid',
    name: 'live',
    component: live,
    meta: {
      title: '',
      description: '',
      keywords: ''
    }
  },
  {
    path: '/diypage/:name',
    name: 'custom',
    component: custom,
  },
  {
    path: '/tearchcms',
    name: 'tearchcms',
    component: () => import('@/pages/tearchcms'),
    meta: {
      title: '教学成果展-翼狐云课堂'
    }
  },
  {
    path: '/exhibitions/:id?',
    name: 'exhibitions',
    component: () => import('@/pages/exhibitions'),
    meta: {
      title: '教学成果展-翼狐云课堂'
    }
  },
  {
    path: '/major/:id?',
    name: 'major',
    component: () => import('@/pages/major'),
    meta: {
      title: '教学成果展-翼狐云课堂'
    }
  },
  {
    path: '/works/:id?',
    name: 'works',
    component: () => import('@/pages/works'),
    meta: {
      title: '教学成果展-翼狐云课堂',
      type: 'isWork'
    }
  },
  {
    path: '/workDetail/:id?',
    name: 'workDetail',
    component: () => import('@/pages/workDetail'),
    meta: {
      title: '教学成果展-翼狐云课堂'
    }
  },
  {
    path: '/workcms/:id?',
    name: 'workcms',
    component: () => import('@/pages/workcms'),
    meta: {
      title: '专业群成果展-翼狐云课堂'
    }
  },
  {
    path: '/authorDetail/:id?',
    name: 'authorDetail',
    component: () => import('@/pages/authorDetail'),
    meta: {
      title: '教学成果展-翼狐云课堂'
    }
  },
  {
    path: '/workup/:id?',
    name: 'workup',
    component: () => import('@/pages/workup'),
    meta: {
      title: '教学成果展-翼狐云课堂'
    }
  },
  {
    path: '/workUpload/:id?',
    name: 'workUpload',
    component: () => import('@/pages/workUpload'),
    meta: {
      title: '教学成果展-翼狐云课堂'
    }
  },
  {
    path: '/studentcms',
    name: 'studentcms',
    component: () => import('@/pages/studentcms'),
    meta: {
      title: '学生作品展-翼狐云课堂'
    }
  },
  {
    path: '/stuUpcms/:id?',
    name: 'stuUpcms',
    component: () => import('@/pages/stuUpcms'),
    meta: {
      title: '学生作品上传-翼狐云课堂'
    }
  },
  {
    path: '/stuWorkdtcms/:id?/:type?',
    name: 'stuWorkdtcms',
    component: () => import('@/pages/stuWorkdtcms'),
    meta: {
      title: '学生作品详情-翼狐云课堂'
    }
  },
  {
    path: '/teamcms',
    name: 'teamcms',
    component: () => import('@/pages/teamcms'),
    meta: {
      title: '师资团队-翼狐云课堂'
    }
  },
  {
    path: '/teamdtcms/:id',
    name: 'teamdtcms',
    component: () => import('@/pages/teamdtcms'),
    meta: {
      title: '师资详情-翼狐云课堂'
    }
  },
  {
    path: '/infocms',
    name: 'infocms',
    component: () => import('@/pages/infocms'),
    meta: {
      title: '咨讯通告-翼狐云课堂'
    }
  },
  {
    path: '/infodtcms/:id?',
    name: 'infodtcms',
    component: () => import('@/pages/infodtcms'),
    meta: {
      title: '咨讯详情-翼狐云课堂'
    }
  },
  {
    path: '/diypages/:href/:id',
    name: 'Diypages',
    component: () => import('@/pages/diypage/diypages'),
    meta: {
      title: '多级自定义页面-翼狐云课堂'
    }
  },
  {
    path: '/diypage/:href',
    name: 'Diypage',
    component: () => import('@/pages/diypage/index'),
    meta: {
      title: '自定义页面-翼狐云课堂'
    }
  },
  {
    path: '/modelSquare',
    name: 'ModelSquare',
    component: () => import('@/pages/modelSquare'),
    meta: {
      title: '模型广场-翼狐云课堂'
    }
  },
  {
    path: '/modelDetails/:id?',
    name: 'ModelDetails',
    component: () => import('@/pages/modelDetails'),
    meta: {
      title: '模型详情-翼狐云课堂'
    }
  },
  {
    path: '/myWorks',
    name: 'MyWorks',
    component: () => import('@/pages/myWorks'),
    meta: {
      title: '模型详情-翼狐云课堂'
    }
  },
  {
    path: '/ai-tool/comfyui',
    name: 'Comfyui',
    component: () => import('@/pages/comfyui'),
    meta: {
      title: 'comfyui-翼狐云课堂'
    }
  },

]

// {
//   path: '/ai-tool/',
//   name: 'AITool',
//   component: () => import('@/pages/AITool'),
//   meta: {
//     title: 'AITool-翼狐云课堂'
//   },
//   beforeEnter: (to, from, next) => {
//     if (!getToken()) {
//       Message.warning("请先登录！")
//       return next(from.path);
//     }
//     next();
//   },
// },
// 解决两次访问相同路由地址报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

let routerBase = '/'
if (process.env.NODE_ENV == 'development') { // 本地开发才需要改写路由根目录
  // 有机构id，改写路由根目录为'/organization.id/'
  if (organization.id) {
    routerBase = `/${organization.id}/`
  }
}



const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: routes,
    base: routerBase
  })

const router = createRouter()

// const router = new Router({
//   mode: 'history',
//   routes: routes,
//   base: routerBase
// })


// router.beforeEach(async (to, from, next) => {
//   // const hasHome = store.getters.perhome
//   // if (hasHome == 1) {

//   // } else if (hasHome == 2) {
//   //   if (hasToken) {
//   //     if (to.path === '/login') {
//   //       next({ path: '/' })
//   //     } else {
//   //       if (hasRoles) {
//   //         next()
//   //       } else {
//   //         try {
//   //           router.addRoutes(stuRoutes)
//   //           next({ ...to, replace: true })
//   //         } catch (error) {
//   //           next(`/login?redirect=${to.path}`)
//   //         }
//   //       }
//   //     }
//   //   }
//   // } else {
//   //   await headerInfo().then(response => {
//   //     const resData = response.data;
//   //     store.commit('SET_HOME',resData.website.is_home);
//   //     store.commit('SET_INTEREST', resData.website.is_lear_interest);
//   //     if (resData.website.is_home == 2) {

//   //       next({ path: '/login' })
//   //     }
//   //   }).catch(error => {
//   //     console.log(error);
//   //   });
//   // }


//   // let meta = to.meta
//   // if (meta.title) {
//   //   document.title = meta.title
//   // }
//   // if (meta.description) {
//   //   document.querySelector('meta[name="description"]').content = meta.description
//   // }

//   // if (meta.keywords) {
//   //   document.querySelector('meta[name="keywords"]').content = meta.keywords
//   // }
//   // 旧路由配置
//     if (to.matched.length === 0) { // 如果未匹配到路由
//       from.path ? next({ path: from.path }) : next('/') // 如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
//     } else {
//       next() // 如果匹配到正确跳转
//     }
//   // 旧路由配置_end
// })


router.beforeEach((to, from, next) => {
  let token = to.query.token
  if (token) {
    store.commit('user/SET_TOKEN', token)
    setToken(token)
    next({ path: to.path, query: null })
    return
  }
  // 判断是否为云课堂机构打开
  if (store.getters.orgInfo.system_type == 2) {
    if (to.name == "404") {
      next();
    } else {
      next({
        path: '/404page',
      })
    }
  } else if (!getToken() && to.name == 'ModelSquare') {
    next(from.path)
    eventBus.$emit("openLoginDialog");
  } else {
    next()
  }
})

router.beforeResolve((to, from, next) => {
  // console.log(to.name+' beforeResolve');
  next()
})

router.afterEach((to, from) => {
  // console.log(to.name+'导航完成');
})

router.onError(callback => {
  // console.log(callback)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js